import React from "react";
export function ProductIntro() {
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-159" data-mp="16r4zkaud39ob">
      <div className="mx-auto max-w-3xl text-center" data-id="element-160" data-mp="22lotydzru0vo">
        <p className="text-[11px] font-semibold tracking-[0.25em] text-gold sm:text-sm" data-id="element-161" data-mp="22jc65k7c0wap">LE SYSTÈME « IMPRIMEZ & ENSEIGNEZ » POUR PROFESSEURS DE GUITARE</p>
        <h2 className="mt-3 font-display text-4xl uppercase text-cream sm:text-6xl" data-id="element-162" data-mp="1soacqc60x82b">
          Le Maître <span className="text-gold" data-id="element-163" data-mp="2gduyt3xh4lft">de la Guitare™</span>
        </h2>
        <p className="mt-4 font-serif text-lg italic text-cream sm:text-xl" data-id="element-164" data-mp="2lbn2swbe7y0d">
          2 livres complémentaires + 5 bonus offerts pour préparer tout votre trimestre.
        </p>
        <p className="mt-5 text-mute" data-id="element-165" data-mp="26l60laqxp42f">
          Le livre théorique vous aide à expliquer les notions essentielles. Le livre pratique vous permet de les appliquer en cours avec vos élèves. Les 5 bonus complètent le tout avec des tablatures, des mélodies, un calendrier d'exercices, des exercices techniques et des fiches de cours.
        </p>
        <p className="mt-3 text-sm text-mute" data-id="element-166" data-mp="uevsuknx7bd6">
          Tout est livré en PDF, envoyé par e-mail. Pas de vidéos, pas de livres audio, aucune plateforme à laquelle se connecter.
        </p>
      </div>
    </section>;
}